import axios from "axios";
import { Payout_Service } from '../Url';

export const PartnerPayoutLanDataAction = {
  GET_PARTNER_PAYOUT_LANDATA_SUCCESS: "GET_PARTNER_PAYOUT_LANDATA_SUCCESS",
  GET_PARTNER_PAYOUT_LANDATA_FAILURE: "GET_PARTNER_PAYOUT_LANDATA_FAILURE",
};


export function partnerpayoutLanReportSummary(props) {
  const { accessToken, reportId, partnerId } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "Post",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url:`http://localhost:8301/partner-payout-service/reports/get/monthly/partnerSummaryData?report_id=${reportId}&partner_id=${partnerId}`,
        url: `${Payout_Service}/reports/get/monthly/partnerSummaryData?report_id=${reportId}&partner_id=${partnerId}`,
      });
      const data = response.data;
      dispatch({
        type: PartnerPayoutLanDataAction.GET_PARTNER_PAYOUT_LANDATA_SUCCESS,
        payload: data.data,
      });
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: PartnerPayoutLanDataAction.GET_PARTNER_PAYOUT_LANDATA_FAILURE,
        payload: error.message || "Failed to fetch partner payout landata",
      });
      return error;
    }
  };
}